import { render, staticRenderFns } from "./_search_result.vue?vue&type=template&id=34cda9cc&lang=pug"
import script from "./_search_result.vue?vue&type=script&lang=js"
export * from "./_search_result.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports